import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Classes from './index.module.css';

function Ratings() {
    return (
        <div className="Ratings">
            <Container>
                <div className={Classes.total_reviews_block}>
                    {/* <h2 className={Classes.total_reviews_block_head}>34,689 Reviews</h2> */}
                    <React.Fragment>
                        <Row>
                            <Col sm={12} lg={4} style={{ zIndex: '1' }}>
                                <div style={{ alignItems: 'center' }}>
                                    <p className={Classes.rating_values1}>87%</p>
                                    <ProgressBar
                                        className={Classes.progress_bar}
                                        id={Classes.progress_bar5}
                                        now={87}

                                    />
                                    <p>
                                        <span className={Classes.starrating5}>★★★★★</span>
                                    </p>
                                </div>
                            </Col>
                            <Col sm={12} lg={4} style={{ zIndex: '1' }}>

                                <div style={{ alignItems: 'center' }}>
                                    <p className={Classes.rating_values2}>11%</p>
                                    <ProgressBar
                                        className={Classes.progress_bar}
                                        id={Classes.progress_bar4}
                                        now={15}
                                    />
                                    <p>
                                        <span className={Classes.starrating4}>★★★★</span>
                                    </p>
                                </div>
                            </Col>
                            <Col sm={12} lg={4} style={{ zIndex: '1' }}>
                                <div style={{ alignItems: 'center' }}>
                                    <p className={Classes.rating_values3}>1%</p>
                                    <ProgressBar
                                        className={Classes.progress_bar}
                                        id={Classes.progress_bar3}
                                        now={5}
                                    />
                                    <p>
                                        <span className={Classes.starrating3}>★★★</span>
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </React.Fragment>
                </div>
            </Container>
        </div>
    )
}

export default Ratings;